export default {
    student: {
        courseFinder: [
            {
                termId: null,
                departmentId: null,
                courseId: null,
                sectionId: null,
                courses: [],
                sections: [],
                departments: []

            },
            {
                termId: null,
                departmentId: null,
                courseId: null,
                sectionId: null,
                courses: [],
                sections: [],
                departments: []

            },
            {
                termId: null,
                departmentId: null,
                courseId: null,
                sectionId: null,
                courses: [],
                sections: [],
                departments: []

            },
            {
                termId: null,
                departmentId: null,
                courseId: null,
                sectionId: null,
                courses: [],
                sections: [],
                departments: []

            }
        ]
    },
    terms: [],
    selectedSections: [],
    isLoading: false,
    adoptions: [],
    adoptionsbyinstructor: [
        {
            id: null,
            department: {},
            course: {},
            adoptions: []
        }
    ],
    facultyselections: {
        instructorId: null,
        termId: null,
        adoptionTypes: null
    },
    searchResults: [{
        isbn: null,
        title: null,
        publisher: null,
        edition: null,
        coverPage: null,
        bookAuthors: null
    }],
    newAuthors: [{ Name: '' }],
    username: localStorage.getItem("username") ? localStorage.getItem("username") : null,
    sisUserId: localStorage.getItem("sisUserId") ? localStorage.getItem("sisUserId") : null,
    token: localStorage.getItem("access_token"),
    isLoggedIn: localStorage.getItem("loggedIn") ? true : false,
    // isDepartmentChair: localStorage.getItem("isDepartmentChair")?localStorage.getItem("isDepartmentChair"):null,
    isSnackbarEnabled: false,
    snackBarMessage: '',
    snackBarStatus: null
}
